import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormAutocomplete, FormContext, FormTextField } from '@eas/common-web';
import { useLegalForms } from '@modules/dict-legal-form/dict-legal-form-api';
import { autocompleteLabelMapper } from '@components/form/misc/label-mappers';

export const legalEntityFields = [
  'companyName',
  'ico',
  'dic',
  'taxRegistrationNumber',
  'esIdCode',
  'legalEntityIdCode',
  'eori',
  'exciseNumber',
  'legalForm',
];

export function LegalEntityFields() {
  const { setFieldValue } = useContext(FormContext);
  const legalForms = useLegalForms();

  return (
    <>
      <FormTextField
        name="companyName"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__NAME"
            defaultMessage="Název"
          />
        }
        notifyChange={() => {
          setFieldValue('identification', null);
        }}
        required
      />
      <FormTextField
        name="ico"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__ICO"
            defaultMessage="IČO"
          />
        }
        notifyChange={() => {
          setFieldValue('identification', null);
        }}
      />
      <FormTextField
        name="dic"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__DIC"
            defaultMessage="DIČ"
          />
        }
      />
      <FormTextField
        name="taxRegistrationNumber"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__TAX_REGISTRATION_NUMBER"
            defaultMessage="Daňové registrační číslo"
          />
        }
      />
      <FormTextField
        name="esIdCode"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__ES_ID_CODE"
            defaultMessage="Identifikační kód ES"
          />
        }
      />
      <FormTextField
        name="legalEntityIdCode"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__LEGAL_ENTITY_ID_CODE"
            defaultMessage="Identifikační kód právnické osoby"
          />
        }
      />
      <FormTextField
        name="eori"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__EORI"
            defaultMessage="EORI"
          />
        }
      />
      <FormTextField
        name="exciseNumber"
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__EXCISE_NUMBER"
            defaultMessage="Číslo pro účely spotřebních daní"
          />
        }
      />
      <FormAutocomplete
        name="legalForm"
        source={legalForms}
        label={
          <FormattedMessage
            id="ES__SUBJECTS__DETAIL__FIELD_LABEL__LEGAL_FORM"
            defaultMessage="Právní forma"
          />
        }
        labelMapper={autocompleteLabelMapper}
      />
    </>
  );
}
